import { Card, CardContent, Grid2 } from '@mui/material';
import React from 'react';

import { ASSESSMENT_RESULT_MAP } from '@constants/assessment';

import Title from './Description';
import ReferenceRange from './ReferenceRange';

interface SectionProps {
  type: string;
}

export default function Section({ type }: SectionProps) {
  if (!ASSESSMENT_RESULT_MAP.has(type)) {
    return null;
  }

  return (
    <Card>
      <CardContent>
        <Grid2 container spacing={3}>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Title code={type} />
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <ReferenceRange code={type} />
          </Grid2>
        </Grid2>
      </CardContent>
    </Card>
  );
}
